<tg-row>
    <tg-col lg="6" sm="12">
        <div
            class="
                property-summary-page__section
                property-summary-page__section--ruled
            ">
            <property-summary-agent-contact-detail
                [contactDetailType]="propertyAgentContactDetailsType.primary"
                [stepIds]="stepIds"
                [contactDetailData]="values[propertyAgentContactDetailsType.primary]">
            </property-summary-agent-contact-detail>
        </div>
    </tg-col>
</tg-row>
<tg-row *ngIf="isSecondContactDetailAdded">
    <tg-col lg="6" sm="12">
        <div
            class="
                property-summary-page__section
                property-summary-page__section--ruled
            ">
            <property-summary-agent-contact-detail
                [contactDetailType]="propertyAgentContactDetailsType.secondary"
                [stepIds]="stepIds"
                [contactDetailData]="values[propertyAgentContactDetailsType.secondary]">
            </property-summary-agent-contact-detail>
        </div>
    </tg-col>
</tg-row>
